/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-06-14 13:30:37
 */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Spin } from 'sup-ui';
import messages from '../messages';
import PackDetail from './PackDetail';

import { getPacklistApi } from 'root/services/packageManage';
import { getHostDetailApi } from 'root/services/disk';
import NoSupos from 'root/components/NoSupos';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

import styles from '../index.less';

const List = () => {
  const intl = useIntl();

  const [dataSource, setDataSource] = useState<any>([]);
  const [spinning, setSpinning] = useState(false);
  const [hasHost, setHasHost] = useState(false); // 是否有部署主机
  const { acitveKey } = useSelector((state: reducerStates) => state.envManage);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // 只有当前tab等于系统管理时才调接口
    if (!sessionStorage.getItem('runtimeEnvId')) return;

    if (acitveKey === '1') {
      serverNodeLabelStatus();
    }
  }, [acitveKey]);

  const getData = () => {
    setSpinning(true);
    getPacklistApi()
      .then((res) => {
        const { data } = res;
        // 筛选catalog为system的安装包 type为整包  1:整包 2补丁包
        let newData: any = [];
        data.map((item: any) => {
          item.specifics = item.specifics.filter((i: any) => i.catalog === 'system' && i.type === 1);
          item.specifics.forEach((sp: any) => {
            sp.name = item.name;
          });
          newData = newData.concat(item.specifics);
          return item;
        });

        setDataSource(newData);
      })
      .finally(() => {
        setSpinning(false);
      });
  };

  const serverNodeLabelStatus = () => {
    getHostDetailApi({ ids: [], nameOrIp: '' }).then((res) => {
      const { data } = res;
      const { labelStatusGroupNotUsed, labelStatusGroupUsed } = data;
      if (labelStatusGroupNotUsed.length || labelStatusGroupUsed.length) {
        setHasHost(true);
        return;
      }
      setHasHost(false);
    });
  };

  return (
    <Spin spinning={spinning} wrapperClassName={styles.sysSpin}>
      <div className={styles.package_manage_list}>
        <div className={styles.list}>
          <div className={styles.operate}>
            <span> {intl.formatMessage(messages.packageList)} </span>
            <div className={styles.refersh}>
              <Button onClick={getData}>{intl.formatMessage(messages.refersh)}</Button>
            </div>
          </div>

          <div className={styles.content}>
            {dataSource?.length ? (
              <div>
                <div className={styles.pack_title}>
                  {`${intl.formatMessage(messages.supOSPackage)}(${dataSource?.length})`}
                </div>
                {dataSource?.map((item: any) => (
                  <PackDetail key={item.archiveId} data={item} hasHost={hasHost} />
                ))}
              </div>
            ) : (
              <NoSupos />
            )}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default List;
